(function($) {

	$(document).ready(function() {
		var menu = document.querySelector('#wrapper-navbar');
		var bmBtn = document.querySelector('.navbar-toggler');
		var html = document.querySelector('html');
		var menuPrevent = document.querySelector('.menu-prevent');
		var mainBackground = document.querySelector('.main-background');
		var allPrevent = document.querySelectorAll('.menu-prevent');
		var isMobileView = false;

		if (bmBtn) {
			bmBtn.addEventListener('click', function() {
				menu.classList.toggle('mb-menu-active');
				html.classList.toggle('no-scroll');

				if (mainBackground) {
					var whiteLogo = mainBackground.querySelector('.logo');
					var menuLogo = mainBackground.querySelector('.mobile-menu-logo');

					whiteLogo.classList.toggle('d-none');
					menuLogo.classList.toggle('d-none');
				}

				if (menuPrevent) {
					if (menuPrevent.classList.contains('first-click')) {
						menuPrevent.classList.remove('mega-toggle-on');
						menuPrevent.classList.remove('first-click');
					}
				}
			});
		}

		function setScreenWidthFlag() {
			if ( $(window).width() > 768) {
				isMobileView = false;
			}
			else {
				isMobileView = true;
			}
		}

		setScreenWidthFlag();


		if (isMobileView) {
			if (menuPrevent) {
				$(allPrevent).each(function() {
					this.addEventListener('click', function(e) {
						e.preventDefault();

						if (this.classList.contains('first-click')) {
							this.classList.remove('mega-toggle-on');
							this.classList.remove('first-click');
						} else {
							if (this.classList.contains('mega-toggle-on')) {
								this.classList.add('first-click');
							}
						}
					});
				});
			}
		}

		$(window).on("resize", function (e) {
			setScreenWidthFlag();

			var win = $(this); //this = window
			if (win.width() >= 768 && html.classList.contains('no-scroll')) {
				bmBtn.click();
			}
		});


		var bubblesBlock = document.querySelectorAll('.content-bubbles-block');

		if (bubblesBlock.length > 0) {
			$('.content-bubbles-block').each(function() {
				var $block = $(this);
				var $slider = $block.find('.content-bubbles-slider-container');
				var $navigation = $block.find('.content-bubble-navigation');

				var slickOptions = {
					dots: false,
					infinite: false,
					speed: 400,
					slidesToShow: 1,
					slidesToScroll: 1,
					variableWidth: true,
					prevArrow: $navigation.find('.content-bubble-prev'),
					nextArrow: $navigation.find('.content-bubble-next'),
					mobileFirst: true, // Reads breakpoints from bottom up (Mobile -> Desktop)
					responsive: [
						{
							breakpoint: 767.98, // At this width and higher...
							settings: "unslick" // ...completely destroy the slider
						}
					]
				};


				$slider.slick(slickOptions);

				$(window).on('resize', function() {
					if ($(window).width() <= 767.98) {
						if (!$slider.hasClass('slick-initialized')) {
							$slider.slick(slickOptions);
						}
						$navigation.show();
					} else {
						$navigation.hide();
					}
				});

				if ($(window).width() > 767.98) {
					$navigation.hide();
				}
			});
		}

		const details = document.querySelectorAll("details");
		if (details.length > 0) {
			class Accordion {
				constructor(el) {
					// Store the <details> element
					this.el = el;
					// Store the <summary> element
					this.summary = el.querySelector('summary');
					// Store the <div class="content"> element
					this.content = el.querySelector('.details-content');

					// Store the animation object (so we can cancel it if needed)
					this.animation = null;
					// Store if the element is closing
					this.isClosing = false;
					// Store if the element is expanding
					this.isExpanding = false;
					// Detect user clicks on the summary element
					this.summary.addEventListener('click', (e) => this.onClick(e));
				}

				onClick(e) {
					// Stop default behaviour from the browser
					e.preventDefault();
					// Add an overflow on the <details> to avoid content overflowing
					this.el.style.overflow = 'hidden';
					// Check if the element is being closed or is already closed
					if (this.isClosing || !this.el.open) {
						this.open();
						// Check if the element is being opened or is already open
					} else if (this.isExpanding || this.el.open) {
						this.shrink();
					}
				}

				shrink() {
					// Set the element as "being closed"
					this.isClosing = true;
					this.el.classList.add('close-animate');

					// Store the current height of the element
					const startHeight = `${this.el.offsetHeight}px`;
					// Calculate the height of the summary
					const endHeight = `${this.summary.offsetHeight}px`;

					// If there is already an animation running
					if (this.animation) {
						// Cancel the current animation
						this.animation.cancel();
					}

					// Start a WAAPI animation
					this.animation = this.el.animate({
						// Set the keyframes from the startHeight to endHeight
						height: [startHeight, endHeight]
					}, {
						duration: 400,
						easing: 'ease-out'
					});

					// When the animation is complete, call onAnimationFinish()
					this.animation.onfinish = () => this.onAnimationFinish(false);
					// If the animation is cancelled, isClosing variable is set to false
					this.animation.oncancel = () => this.isClosing = false;
					this.el.classList.remove('close-animate');
				}

				open() {
					// Apply a fixed height on the element
					this.el.style.height = `${this.el.offsetHeight}px`;
					// Force the [open] attribute on the details element
					this.el.open = true;
					// Wait for the next frame to call the expand function
					window.requestAnimationFrame(() => this.expand());
				}

				expand() {
					// Set the element as "being expanding"
					this.isExpanding = true;
					this.el.classList.add('open-animate');
					// Get the current fixed height of the element
					const startHeight = `${this.el.offsetHeight}px`;
					// Calculate the open height of the element (summary height + content height)
					const endHeight = `${this.el.offsetHeight + this.content.offsetHeight}px`;

					// If there is already an animation running
					if (this.animation) {
						// Cancel the current animation
						this.animation.cancel();
					}

					// Start a WAAPI animation
					this.animation = this.el.animate({
						// Set the keyframes from the startHeight to endHeight
						height: [startHeight, endHeight]
					}, {
						duration: 600,
						easing: 'ease'
					});
					// When the animation is complete, call onAnimationFinish()
					this.animation.onfinish = () => this.onAnimationFinish(true);
					// If the animation is cancelled, isExpanding variable is set to false
					this.animation.oncancel = () => this.isExpanding = false;
					this.el.classList.remove('open-animate');
				}

				onAnimationFinish(open) {
					// Set the open attribute based on the parameter
					this.el.open = open;
					// Clear the stored animation
					this.animation = null;
					// Reset isClosing & isExpanding
					this.isClosing = false;
					this.isExpanding = false;
					// Remove the overflow hidden and the fixed height
					this.el.style.height = this.el.style.overflow = '';
				}
			}

			document.querySelectorAll('details').forEach((el) => {
				new Accordion(el);
			});
		}

	})

})(jQuery);
